export default "__VITE_ASSET__ef51a31c__"